import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import FiscContratosService from '../../../../../../services/fiscContratos-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Fiscal = () => {
    let { id } = useParams()

    const [servidor, setServidor] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [matricula, setMatricula] = useState("");
    const [posicao, setPosicao] = useState("");
    const [objeto, setObjeto] = useState("");
    const [secs, setSecs] = useState("");
    const [referencia, setReferencia] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchFiscal(id) {
        await montaSelectLocais();
        const response = await FiscContratosService.fiscEdit(id);
        setServidor(response.data["servidor"]);
        setSecretaria(response.data["secretaria"]);
        setMatricula(response.data["matricula"]);
        setPosicao(response.data["posicao"]);
        setObjeto(response.data["objeto"]);
        setReferencia(response.data["referencia"]);
        setAno(response.data["ano"]);
    }

    useEffect(() => {
        fetchFiscal(id);
    }, [id]);

    const montaSelectLocais = async () => {
        let prod = await FiscContratosService.listar();
        const uniqueSecs = [...new Map(prod.data.map(item => [item['secretaria'], item])).values()];
        setSecs(uniqueSecs)
    }


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const fiscal = await FiscContratosService.editar(id, {
                servidor: servidor,
                secretaria: secretaria,
                matricula: matricula,
                posicao: posicao,
                objeto: objeto,
                referencia: referencia,
                ano: ano
            })
            if (fiscal.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="servidor">
                                <FloatingLabel
                                    label="Servidor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="servidor"
                                        value={servidor}
                                        onChange={e => setServidor(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {secs.length > 1 ? <Col lg={12}>
                            <Form.Group className="mb-3" controlId="Plataforma">
                                <FloatingLabel
                                    label="Secretarias"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretarias"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option value={secretaria}>{secretaria}</option>
                                        {secs.map((sec) =>
                                            <option value={sec.secretaria}>{sec.secretaria}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col> : null}
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="matricula">
                                <FloatingLabel
                                    label="Matrícula"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="matricula"
                                        value={matricula}
                                        onChange={e => setMatricula(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Referencia">
                                <FloatingLabel
                                    label="Referência"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="referencia"
                                        name="referencia"
                                        onChange={e => setReferencia(e.target.value)}
                                    >
                                        <option value={referencia}>{referencia}</option>
                                        <option value="1º Semestre">1º Semestre</option>
                                        <option value="2º Semestre">2º Semestre</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="posicao">
                                <FloatingLabel
                                    label="Posição"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="posicao"
                                        name="posicao"
                                        onChange={e => setPosicao(e.target.value)}
                                    >
                                        <option value={posicao}>{posicao}</option>
                                        <option value="Titular">Titular</option>
                                        <option value="Suplente">Suplente</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="objeto">
                                <FloatingLabel
                                    label="Objeto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/contratos/fiscais/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Fiscal editado com sucesso!</Alert>
                <Navigate to={'/restrito/contratos/fiscais/listar'} />
            </Fragment>
        )
    }
}

export default Fiscal;